class CurrencyLocalizationForm extends HTMLElement {
  constructor() {
    super();
    this.form = this.querySelector('form');
    this.select = this.querySelector('select');

    if (this.select && this.form) {
      this.select.addEventListener('change', this.onChange.bind(this));
      this.evaluateRouting(false);
    }
  }

  onChange() {
    this.evaluateRouting(true);
  }

  redirectToUsProduct(usStoreUrl, productHandle) {
    const productUrl = `${usStoreUrl}/products/${productHandle}${window.location.search}`;
    const jsonUrl = `${usStoreUrl}/products/${productHandle}.json`;

    fetch(jsonUrl)
      .then((res) => {
        window.location.href = res.ok ? productUrl : `${usStoreUrl}/`;
      })
      .catch(() => {
        window.location.href = `${usStoreUrl}/`;
      });
  }

  evaluateRouting(isUserAction) {
    const storeCountry = this.select.dataset.storeCountry;
    const usStoreUrl = (this.select.dataset.usStoreUrl || 'https://us.elleandriley.com').replace(
      /\/$/,
      '',
    );
    const productHandle = this.select.dataset.productHandle;
    const isAnz = storeCountry === 'NZ' || storeCountry === 'AU';

    const selectedOption = this.select.options[this.select.selectedIndex];
    if (!selectedOption) return;

    const currency = selectedOption.dataset.currency;

    if (isAnz && currency === 'USD') {
      if (productHandle) {
        this.redirectToUsProduct(usStoreUrl, productHandle);
      } else {
        window.location.href = `${usStoreUrl}/`;
      }
      return;
    }

    if (isUserAction) {
      this.form.submit();
    }
  }
}

if (!customElements.get('currency-localization-form')) {
  customElements.define('currency-localization-form', CurrencyLocalizationForm);
}
